import { __assign } from "tslib";
import { S3ActionTypes } from '../actions/s3.actions';
export var initialState = {
    config: null,
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case S3ActionTypes.GetS3OptionsSuccess: {
            return __assign(__assign({}, state), { config: action.payload });
        }
        default: {
            return state;
        }
    }
}
